import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './styles.css';

class Button extends Component {
  constructor(props) {
    super(props);

    this.onOver = this.onOver.bind(this);
    this.onOut = this.onOut.bind(this);

    this.state = {
      hover: false,
    };
  }

  componentDidMount() {
    this.button.addEventListener('mouseover', this.onOver);
    this.button.addEventListener('mouseout', this.onOut);
    if ('ontouchstart' in window) {
      this.button.addEventListener('touchstart', this.onOver);
      this.button.addEventListener('touchend', this.onOut);
    }
  }

  componentWillUnmount() {
    this.button.removeEventListener('mouseover', this.onOver);
    this.button.removeEventListener('mouseout', this.onOut);
    if ('ontouchstart' in window) {
      this.button.removeEventListener('touchstart', this.onOver);
      this.button.removeEventListener('touchend', this.onOut);
    }
  }

  onOver() {
    this.setState({
      hover: true,
    });
  }

  onOut() {
    this.setState({
      hover: false,
    });
  }

  render() {
    let className = 'button';

    if (this.props.className) className += ` ${this.props.className}`;
    if (this.props.color) className += ` button--${this.props.color}`;
    if (this.props.size) className += ` button--${this.props.size}`;
    if (this.props.full) className += ' button--full';
    if (this.state.hover) className += ' button--hover';

    switch (this.props.type) {
      case 'button':
        return (
          <div
            className={className}
            ref={(button) => { this.button = button; }}
          >
            <button
              className="button__link"
              disabled={this.props.disabled}
              onClick={this.props.onClick}
            >
              {(this.props.imgLeft) ? (<img className="button__img button__img--left" src={this.props.imgLeft} alt="" />) : null}
              {this.props.text}
              {this.props.children}
              {(this.props.imgRight) ? (<img className="button__img button__img--right" src={this.props.imgRight} alt="" />) : null}
            </button>
          </div>
        );
      case 'link':
        return (
          <div
            className={className}
            ref={(button) => { this.button = button; }}
          >

            <a
              className="button__link"
              target={this.props.target}
              href={this.props.href}
            >
              {(this.props.imgLeft) ? (<img className="button__img button__img--left" src={this.props.imgLeft} alt="" />) : null}
              {this.props.text}
              {this.props.children}
              {(this.props.imgRight) ? (<img className="button__img button__img--right" src={this.props.imgRight} alt="" />) : null}
            </a>
          </div>
        );
      case 'submit':
        return (
          <div
            className={className}
            ref={(button) => { this.button = button; }}
          >
            <button
              className="button__link"
              disabled={this.props.disabled}
              type="submit"
            >
              {(this.props.imgLeft) ? (<img className="button__img button__img--left" src={this.props.imgLeft} alt="" />) : null}
              {this.props.text}
              {this.props.children}
              {(this.props.imgRight) ? (<img className="button__img button__img--right" src={this.props.imgRight} alt="" />) : null}
            </button>
          </div>
        );
      default:
        return (
          <div
            className={className}
            ref={(button) => { this.button = button; }}
          >
            <Link
              className="button__link"
              target={this.props.target}
              to={this.props.href}
            >
              {(this.props.imgLeft) ? (<img className="button__img button__img--left" src={this.props.imgLeft} alt="" />) : null}
              {this.props.text}
              {this.props.children}
              {(this.props.imgRight) ? (<img className="button__img button__img--right" src={this.props.imgRight} alt="" />) : null}
            </Link>
          </div>
        );
    }
  }
}

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  full: PropTypes.bool,
  type: PropTypes.string,
  imgLeft: PropTypes.string,
  imgRight: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.element,
  target: PropTypes.string,
};

Button.defaultProps = {
  className: '',
  color: '',
  size: '',
  disabled: false,
  full: false,
  onClick: null,
  href: '',
  type: '',
  imgLeft: '',
  imgRight: '',
  text: '',
  children: null,
  target: '',
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.jsx